import React, { useState, useEffect, useRef } from 'react'
import { Chat } from '@progress/kendo-react-conversational-ui'
import { IntlProvider } from '@progress/kendo-react-intl'
import './chatBoxGL.css'
import { useTranslation } from 'react-i18next'

/**
 * @typedef {object} Props
 * @property {import('@progress/kendo-react-conversational-ui').User} user
 * @property {string} [placeholderChat]
 * @property {number} [widthChat]
 * @property {Function} createMessage
 * @property {object[]} conversation
 * @property {boolean} [disabled]
 */

/**
 * @param {Props} props
 */
const ChatBoxGLPure = (props) => {
  const {
    user, //Array with users of the conversation
    placeholderChat, //PlaceHolder to input toolBar
    widthChat, //Width chat
    createMessage, //Function to create message, use message and file
    conversation, //Information of messages that get from getWorkFlowExecutionMessage
    disabled = false
  } = props

  const { t } = useTranslation()
  /** @type {React.MutableRefObject<HTMLInputElement | null>} */
  const fileUpload = useRef(null)
  const [messages, setMessages] = useState(conversation)
  const [messagesActual, setMessagesActual] = useState({})
  const [fileContent, setFileContent] = useState("")
  const handleUploadClick = () => {
    if (disabled) return
    if (fileUpload.current) fileUpload.current.click()
  }

  /** @param {import('@progress/kendo-react-conversational-ui').ChatMessageSendEvent} event */
  const addNewMessage = (event) => {
    if (disabled) return
    setMessages([...messages, event.message])
    setMessagesActual(event.message)
  }

  /**
   * @type {React.ChangeEventHandler<HTMLInputElement>}
   * @returns {void}
   */
  const handleInputChange = (e) => {
    if (disabled) return
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0]
      const reader = new FileReader()

      reader.onloadend = (event) => {
        const message = {
          author: user,
          attachments: [{
            name: file.name,
            content: event.target?.result || '',
            contentType: 'application/pdf',
          }],
        }
        setMessages(prev => [...prev, message])
        setFileContent(file)
      }
      reader.readAsDataURL(file)
    }
  }

  //send message and document to function create message
  useEffect(() => {
    if (
      (messagesActual && messagesActual.author) ||
      (fileContent && fileContent.name)
    ) {
      createMessage(messagesActual, fileContent)
      setMessagesActual({})
      setFileContent("")
    }
  }, [messagesActual, fileContent, createMessage])

  useEffect(() => {
    setMessages(conversation)
  }, [conversation])

  /**
   * @param {import('@progress/kendo-react-conversational-ui').ChatMessageTemplateProps} props
   */
  const MessageTemplate = (props) => {
    return (
      <>
        {props.item.text && props.item.text !== 'undefined' ? (
          <div className='k-bubble'>
            <div>{props.item.text}</div>
          </div>
        ) : null}
      </>
    )
  }

  /*Message box when send file*/
  const AttachmentTemplate = (props) => {
    return (
      <div className='k-card k-card-type-rich chatBox-boxContainer-pdf'>
        {props.item && props.item.name ? (
          <div className='k-card-body quoteCard'>
            <a href={props.item.site} download>
              {props.item.name}
            </a>
          </div>
        ) : (
          <div>{''}</div>
        )}
      </div>
    )
  }

  /*Upload btns, send message and send file*/
  /**
   * @param {{icon: string}}
   */
  const UploadButton = ({ icon }) => {
    return (
      <button
        className={
          'k-button k-button-md k-rounded-md k-button-flat k-button-flat-base k-button k-button-md k-rounded-md k-button-solid k-button-solid-base-icon'
        }
        onClick={handleUploadClick}
        disabled={disabled}
      >
        <span
          className={'k-icon ' + icon}
          style={{
            fontSize: '20px',
          }}
        />
      </button>
    )
  }

  //ToolBar Chat
  const CustomChatMessage = (props) => (
    <>
      <div style={{ opacity: disabled ? 0.2 : 1, pointerEvents: disabled ? 'none' : 'auto', display: 'flex', alignItems: 'center', width: '100%' }}>
        {props.messageInput}
        <UploadButton
          icon='k-i-clip-45'
        />
        {props.sendButton}
      </div>
    </>
  )

  return (
    <div className='chatBoxGLPure-container'>
      <input
        type='file'
        onChange={handleInputChange}
        style={{ display: 'none' }}
        ref={fileUpload}
        accept='application/pdf'
      />
      <IntlProvider locale='es'>
        <Chat
          user={user}
          messages={messages}
          onMessageSend={addNewMessage}
          placeholder={placeholderChat ?? t('chatBot.placeholder')}
          width={widthChat}
          attachmentTemplate={AttachmentTemplate}
          messageBox={CustomChatMessage}
          messageTemplate={MessageTemplate}
          onActionExecute={disabled ? () => { } : createMessage}
        />
      </IntlProvider>
    </div>
  )
}

export { ChatBoxGLPure as default }
